"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { Phone, Instagram, Send, BadgeCheck } from "lucide-react";
import { TOP_BAR_LINKS } from "./footerLinks";
export default function FooterTopBar() {
  const $ = _c(10);
  const slotRef = useRef(null);
  const [docked, setDocked] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const el = slotRef.current;
      if (!el) {
        return;
      }
      const io = new IntersectionObserver(t2 => {
        const [entry] = t2;
        return setDocked(entry.isIntersecting);
      }, {
        threshold: 0
      });
      io.observe(el);
      return () => io.disconnect();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = `w-full h-auto flex flex-col md:flex-row items-center justify-between gap-3 md:gap-6 px-4 sm:px-6 md:px-10 py-3 md:py-0 ${docked ? "md:h-14" : "md:h-10 bg-secondary/5 backdrop-blur-md footer-topbar-floating"}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      borderBottom: "1px solid #80919A"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <nav className="flex flex-wrap items-center justify-center md:justify-start gap-x-5 sm:gap-x-7 gap-y-2 text-xs sm:text-sm text-white/80">{TOP_BAR_LINKS.map(_temp)}</nav>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <a href="https://instagram.com/idehnama.ir" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-primary transition-colors" aria-label={"\u0627\u06CC\u0646\u0633\u062A\u0627\u06AF\u0631\u0627\u0645"}><Instagram size={18} /></a>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <a href="https://t.me/idehnama" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-primary transition-colors" aria-label={"\u062A\u0644\u06AF\u0631\u0627\u0645"}><Send size={18} /></a>;
    t7 = <span className="w-px h-5 bg-white/15 mx-1 hidden sm:inline-block" />;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex items-center gap-3 sm:gap-4">{t5}{t6}{t7}<a href="tel:90000737" className="flex items-center gap-1.5 text-white hover:text-primary transition-colors" aria-label={"\u062A\u0645\u0627\u0633 \u0628\u0627 90000737"}><span className="text-sm font-semibold tracking-wide">90000737</span><Phone size={16} /></a></div>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t2) {
    t9 = <div ref={slotRef} className="footer-topbar-slot w-full h-auto md:h-14"><div className={t2} style={t3}>{t4}{t8}</div></div>;
    $[8] = t2;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}
function _temp(item, idx) {
  return <Link key={`${item.href}-${idx}`} href={item.href} className="hover:text-primary transition-colors">{item.label}</Link>;
}